import { AfterViewInit, Component } from '@angular/core';
import { ShepherdService } from 'angular-shepherd';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-image-analyzer-tour',
  standalone: true,
  imports: [],
  templateUrl: './image-analyzer-tour.component.html',
  styleUrl: './image-analyzer-tour.component.scss'
})
export class ImageAnalyzerComponent implements AfterViewInit {

  private cookieName: string = 'image-analyzer-tour';

  hideRestartLink: boolean = false;

  constructor(private shepherdService: ShepherdService, private cookieService: CookieService) { }

  ngAfterViewInit(): void {

    
  }

  startTour() {
    let defaultSteps: any = [
      {
        id: 'step1',

        buttons: [
          {
            classes: 'shepherd-button-primary',
            text: 'Next',
            type: 'next'
          }
        ],
        classes: '',
        highlightClass: 'highlight',
        scrollTo: false,
        title: 'Image Analyzer',
        text:
          `Using the capture feature on PlayStation, you can take 3 screenshots of specific views in GT7
          and use them here to automatically read in a vehicle's parameters`
        ,
      },
      {
        id: 'step2',
        attachTo: {
          element: '.slot1-selector',
          on: 'bottom'
        },
        title: 'Slot1 - Basic Settings',
        text:
          `<p>The first screenshot is the default view in Car Settings in GT7.</p>
          <img src="/assets/images/screenshot-example-1.jpg" style="width: 100%" />`,
        buttons: [
          {
            classes: 'shepherd-button-primary',
            text: 'Back',
            type: 'back'
          },
          {
            classes: 'shepherd-button-primary',
            text: 'Next',
            type: 'next'
          }
        ],
        classes: 'shepherd-wide-step',
        scrollTo: true
      },
      {
        id: 'step3',
        attachTo: {
          element: '.slot2-selector',
          on: 'top'
        },
        title: 'Slot2 - ECU Graph',
        text:
          `<p>The second screenshot includes the dyno graph in the ECU window.</p>
          <img src="/assets/images/screenshot-example-2.jpg" style = "width: 100%" />`,
        buttons: [
          {
            classes: 'shepherd-button-primary',
            text: 'Back',
            type: 'back'
          },
          {
            classes: 'shepherd-button-primary',
            text: 'Next',
            type: 'next'
          }
        ],
        classes: 'shepherd-wide-step',
        scrollTo: true
      },
      {
        id: 'step4',
        attachTo: {
          element: '.slot3-selector',
          on: 'top'
        },
        title: 'Slot 3 - Transmission',
        text:
          `<p>The third screenshot is of the Manual Adjustment window under Transmission.</p>
            <img src="/assets/images/screenshot-example-3.jpg" style = "width: 100%" />`,
        buttons: [
          {
            classes: 'shepherd-button-primary',
            text: 'Back',
            type: 'back'
          },
          {
            classes: 'shepherd-button-primary',
            text: 'Next',
            type: 'next'
          }
        ],
        classes: 'shepherd-wide-step',
        scrollTo: true
      },
      {
        id: 'step5',
        attachTo: {
          element: '.analyze-button',
          on: 'top'
        },
        title: 'Analyze',
        text:
          `After selecting screenshots from at least 1 slot, click Analyze
          to see the results. Once the analysis has been done, you will have the
          opportunity to change any values before accepting them.`,
        buttons: [
          {
            classes: 'shepherd-button-primary',
            text: 'Back',
            type: 'back'
          },
          {
            classes: 'shepherd-button-primary',
            text: 'Close',
            type: 'next'
          }
        ],
        scrollTo: true
      }
    ]
    //this.shepherdService.defaultStepOptions = defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.confirmCancel = false;
    this.shepherdService.onTourFinish = () => {
      this.cookieService.set(this.cookieName, `completed:${new Date()}`);
      this.hideRestartLink = false;
    };
    this.shepherdService.addSteps(defaultSteps);
    this.shepherdService.start();
  }

  isElementVisible(selector: string) {
    const element = document.querySelector(selector) as HTMLElement;

    return element &&
      element.offsetParent !== null &&
      window.getComputedStyle(element).visibility !== 'hidden';
  }
}
